import { LOADING, SET_MESSAGE } from "../../Actions/Types";
import { domainValidationAPI } from "../../Api/DomainApi/DomainValidationApi";

// service to validate domain
const domainValidationService = async (
    newWebsiteURL: string, // website url
    dispatch: Function, // function to store redux data
    t: Function, // i18next t function
    temporary_domain?: string // temporary domain
) => {

    // Set Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // API to validate domain
    const domainValidationRes = await domainValidationAPI(newWebsiteURL, temporary_domain).then(async (validationRes) => {

        console.log("validationRes", validationRes);
        console.log("validationRes.status", validationRes.status);
        
        // check if website url is validated
        if (validationRes.data && newWebsiteURL.replaceAll(" ", "").replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0] === validationRes.data.domain && validationRes.status === 1) {
            
            const message = validationRes.message === "Alternate Website Already Exist!" 
                ? t('alternateWebsiteExistMsg') 
                : t('Website Exist Msg');
            
            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": message,
                    "toast_type": "danger"
                }
            });

            // remove Loading
            dispatch({
                type: LOADING,
                payload: false,
            });

            return { states: 300 };

        } 
        // check if website is not validated
        else if ((validationRes.data === null || validationRes.data.length === 0) && validationRes.status === 1) {
            
            const message = validationRes.message === "Alternate Website does not exist. Please enter a valid website URL" 
                ? t('alternateWebsiteNotExist') 
                : validationRes.message === "Alternate Website Already Exist!" 
                    ? t('alternateWebsiteExistMsg') 
                    : t('Website Not Exist Msg');

            dispatch({
                type: SET_MESSAGE,
                payload: {
                    "toast_message": message,
                    "toast_type": "danger"
                }
            });

            // remove Loading
            dispatch({
                type: LOADING,
                payload: false,
            });

            return { states: 400 };
            
        } else {

            // remove Loading
            dispatch({
                type: LOADING,
                payload: false,
            });

            return { states: 200 };
        }
    });

    return domainValidationRes;
}

export { domainValidationService }